import { userTypes } from '../consts/userTypes'

export function setClientId(clientId) {
  return {
    type: 'SET_CLIENT_ID',
    clientId
  };
}

export function setUserInfos(user) {
  return {
    type: userTypes.USERS_SET_USER_INFOS,
    user
  };
}

export function tryToConnect() {
  return {
    type: 'TEST'
  }
}

export function downUsernameUpdate(instanceId, userHandlerId, username) {
  return {
    type: userTypes.DOWN_USERS_USERNAME_UPDATE,
    userHandlerId,
    username,
    meta: {
      sendClient: true,
      instanceId: instanceId,
    }
  }
}

export function setConnectionState(state, connected) {
  return {
    type: 'SET_CONNECTION_STATE',
    state,
    connected
  };
}

export function setUserType(userType) {
  return {
    type: 'SET_USER_TYPE',
    userType,
    meta: {
      sendServer: true,
    }
  };
}

// Push new user in the session
export function pushNewUser({ user, sessionId, playerNumber, pooledUserType }) {
  return {
    type: 'PUSH_NEW_USER',
    id: user.userHandlerId,
    userHandlerId: user.userHandlerId,
    userProfileId: user.userProfileId,
    username: user.username,
    userType: user.userType,
    sessionId,
    playerNumber,
    pooledUserType,
    meta: {
      sendClient: true,
    }
  };
}


export function pushRemoveUser(userHandlerId) {
  return {
    type: 'PUSH_REMOVE_USER_FROM_SESSION',
    userHandlerId,
    meta: {
      sendClient: true,
    }
  };
}

export function userDisconnected(userHandlerId) {
  return {
    type: 'USER_DISCONNECTED',
    userHandlerId,
  };
}

export const srvLoadUser = (userHandlerId, user) => ({ type: 'SRV_LOAD_USER', userHandlerId, user })
export const updateUserProfile = (userHandlerId, user) => ({ type: userTypes.USERS_UPDATE_USER_PROFILE, userHandlerId, user })
export const srvRecreateUser = (userHandlerId, user) => ({ type: 'SRV_RECREATE_USER', userHandlerId, user })